export default __webpack_public_path__ + "static/media/241104_Shop_Bilder_Lay2.26783bb3.png";